import { MAX_CONCURRENT_PRODUCT_ADDS } from '../bundle.machine.constants';
import { type ProductAdds } from '../types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * How many more products can be sent now. Products go one at a time until one
 * lands, so the cart exists before the rest are sent.
 */
export function getFreeAddSlotCount(productAdds: ProductAdds) {
  const { added, inFlight } = productAdds;

  const hasAddedProduct = added.length > 0;
  const slotCount = hasAddedProduct ? MAX_CONCURRENT_PRODUCT_ADDS : 1;

  return Math.max(slotCount - inFlight.length, 0);
}
